module.exports = __webpack_public_path__ + "img/logoCPP.eb24bf1e.svg";